<template>
    <v-container :fluid="$vuetify.breakpoint.md" class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col cols="12">
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary white--text py-2"
                                  style="word-break: normal">TICKET Nº {{ id.length < 5 ? ('0000' + id).slice(-4) : id }}
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="6" align-self="stretch">
                <v-card height="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary white--text" style="word-break: normal">DETALLES
                        <v-btn outlined fab x-small class="float-right white--text" @click="details = !details" v-show="$vuetify.breakpoint.smAndDown">
                            <v-icon>{{details ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-divider/>
                    <v-card-subtitle v-show="$vuetify.breakpoint.smAndDown ? details : true" class="text-center pb-6" v-if="info.service_id">
                        <h3><strong>Servicio Nº {{ (info.service_id).length < 5 ? ('0000' + info.service_id).slice(-4) : info.service_id }}</strong></h3>
                    </v-card-subtitle>
                    <v-card-text v-show="$vuetify.breakpoint.smAndDown ? details : true">
                        <v-row justify="center">
                            <v-col cols="6" class="py-0" v-if="user.role !== 'Customer'">
                                <h3 class="text-center"><strong>ID Cliente</strong></h3>
                                <p class="text-center">{{ (info.user_id).toString().padStart(5, 0) }}</p>
                            </v-col>
                            <v-col cols="6" class="py-0" v-if="user.role !== 'Customer'">
                                <h3 class="text-center"><strong>Nombre</strong></h3>
                                <p class="text-center">{{ info.name }}</p>
                            </v-col>
                            <v-col cols="6" class="py-0">
                                <h3 class="text-center"><strong>País</strong></h3>
                                <p class="text-center">{{ info.country_name }}</p>
                            </v-col>
                            <v-col cols="6" class="py-0">
                                <h3 class="text-center"><strong>Departamento</strong></h3>
                                <p class="text-center">{{ info.type }}</p>
                            </v-col>
                            <v-col cols="6" class="py-0">
                                <h3 class="text-center"><strong>Estado</strong></h3>
                                <p class="text-center" v-if="info.status === 301">Reclamo Enviado</p>
                                <p class="text-center" v-else-if="info.status === 302">Respuesta Enviada</p>
                                <p class="text-center" v-else-if="info.status === 303">Respuesta Recibida</p>
                                <p class="text-center" v-else>Reclamo Cerrado</p>
                            </v-col>
                            <v-col sm="6" class="py-0">
                                <h3 class="text-center"><strong>Fecha de Creación</strong></h3>
                                <p class="text-center">{{ info.created_at }}</p>
                            </v-col>
                            <v-col cols="12" class="py-0">
                                <h3 class="text-center"><strong>Asunto</strong></h3>
                                <p class="text-center">{{ info.subject }}</p>
                            </v-col>
                            <v-col cols="12" class="py-6 text-center" v-if="user.role !== 'Customer'">
                                <v-btn color="error" dark elevation="0" @click="openTicket(info.id)" v-if="info.status === 303">
                                    <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Reabrir Ticket
                                </v-btn>
                                <v-btn color="error" dark elevation="0" @click="closeTicket(info.id)" v-else>
                                    <v-icon>mdi-close-circle</v-icon>&nbsp;&nbsp;Cerrar Ticket
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" align-self="stretch">
                <v-card height="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary white--text" style="word-break: normal">MENSAJES</v-card-title>
                    <v-divider/>
                    <v-card-text style="height: 460px; overflow-y: auto; overflow-x: hidden; padding: 0" v-chat-scroll>
                        <template v-for="msg in messages">
                            <v-row v-if="msg.user_id === user.id">
                                <v-col cols="11" offset="1">
                                    <v-list-item class="px-2">
                                        <v-list-item-content class="float-right py-0">
                                            <v-list-item-title>
                                                <b class="float-right grey--text">
                                                    <v-icon size="20" v-if="msg.role !== 'Customer'">mdi-face-agent</v-icon>
                                                    {{ msg.name }} (Tú)
                                                </b>
                                            </v-list-item-title>
                                            <v-img :src="'/' + msg.text"
                                                   alt="Vista Previa" @click="getImg(msg.id)" max-height="160px" max-width="100%" contain position="right center"
                                                   style="cursor: pointer;" v-if="msg.type === 'Img'"/>
                                            <v-list-item-subtitle class="px-4 py-2 light-blue lighten-5 black--text" style="border-radius: 6px; white-space: normal" v-else>{{ msg.text }}</v-list-item-subtitle>
                                            <v-list-item-action-text>
                                                <span class="float-right caption">{{ msg.created_at }}</span>
                                            </v-list-item-action-text>
                                        </v-list-item-content>
                                        <v-list-item-avatar class="ml-2" size="48">
                                            <img src="/img/cliente.jpg" :alt="msg.name" style="border: 1px solid #9e9e9e" v-if="msg.role === 'Customer'">
                                            <img src="/img/soporte.jpg" :alt="msg.name" style="border: 1px solid #9e9e9e" v-else>
                                        </v-list-item-avatar>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col cols="11">
                                    <v-list-item class="px-2">
                                        <v-list-item-avatar class="mr-2" size="48">
                                            <img src="/img/cliente.jpg" :alt="msg.name" style="border: 1px solid #9e9e9e" v-if="msg.role === 'Customer'">
                                            <img src="/img/soporte.jpg" :alt="msg.name" style="border: 1px solid #9e9e9e" v-else>
                                        </v-list-item-avatar>
                                        <v-list-item-content class="py-0">
                                            <v-list-item-title>
                                                <b class="grey--text">{{ msg.name }}
                                                    <v-icon size="20" v-if="msg.role !== 'Customer'">mdi-face-agent</v-icon>
                                                </b>
                                            </v-list-item-title>
                                            <v-img :src="'/' + msg.text"
                                                   alt="Vista Previa" @click="getImg(msg.id)" max-height="160px" max-width="100%" contain position="left center"
                                                   style="cursor: pointer;" v-if="msg.type === 'Img'"/>
                                            <v-list-item-subtitle class="px-4 py-2 grey lighten-3 black--text" style="border-radius: 6px; white-space: normal" v-else>{{ msg.text }}</v-list-item-subtitle>
                                            <v-list-item-action-text>
                                                <span class="caption">{{ msg.created_at }}</span>
                                            </v-list-item-action-text>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                        </template>
                    </v-card-text>
                    <v-divider v-if="info.status === 301 || info.status === 302"/>
                    <v-card-actions class="pb-0" v-if="info.status === 301 || info.status === 302">
                        <v-row justify="center">
                            <v-col cols="12" class="py-0 px-4">
                                <v-form ref="form" @submit.prevent="sendMessage(1)" lazy-validation v-model="valid">
                                    <v-text-field
                                        :label="labels.message"
                                        type="text"
                                        name="message"
                                        counter="1000"
                                        v-model="form.message"
                                        placeholder="Escribe aquí"
                                        filled
                                        clearable
                                        :disabled="loading"
                                        :loading="loading"
                                        :error-messages="errors.email"
                                        :rules="[rules.min('message', 1, 'La'), rules.max('message', 1000, 'La')]"
                                        @input="clearErrors('message')"
                                        prepend-icon="mdi-camera"
                                        @click:prepend="$refs.uploader.click()"
                                        prepend-inner-icon="mdi-emoticon"
                                        @click:prepend-inner=""
                                        :append-icon="loading ? 'mdi-loading' : 'mdi-send'"
                                        @click:append="sendMessage(1)"
                                        clear-icon="mdi-close-circle"
                                        @click:clear="clearMessage"/>
                                </v-form>
                                <input ref="uploader" class="d-none" type="file"
                                       accept="image/*"
                                       @change="onFileChanged">
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
                <v-dialog v-model="view" fullscreen>
                    <v-card color="card">
                        <v-toolbar dark color="primary" class="px-2">
                            <v-btn icon large @click="closeImg" class="bg primary--text">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title class="d-inline-block text-center font-weight-medium pl-0" style="white-space:normal;width:100%">Vista Previa</v-toolbar-title>
                            <div class="flex-grow-1"></div>
                            <v-btn icon large @click="sendMessage(2)" class="bg primary--text" v-if="form.img !== null">
                                <v-icon>mdi-send</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text class="px-0">
                            <v-img :src="img" alt="Vista Previa" max-height="700px" max-width="100%" contain/>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from "../helpers/form";

    export default {
        name: "ClaimView",
        mixins: [ Form ],
        props: [ 'user' ],
        data: () => ({
            id: '',
            info: {},
            messages: [],
            details: false,
            loading: false,
            labels: {
                message: 'Respuesta'
            },
            form: {
                img: null,
                message: ''
            },
            view: false,
            title: null,
            img: null
        }),
        mounted () {
            this.ini();
            this.getTicket();
        },
        methods: {
            ini() {
                this.id = this.$route.params.id;
            },
            getTicket() {
                clearTimeout(this.timeout);
                axios.get('/api/tickets/info/' + this.id)
                    .then((res) => {
                        if (res.data.v === 'success') {
                            this.info = res.data.ticket;
                            this.messages = res.data.messages;
                        } else {
                            this.$toast.warning(res.data.status, { icon: 'mdi-information' });
                        }
                    })
                    .catch(err => {
                        this.handleErrors(err.response.data.errors);
                    });
                this.timeout = setTimeout(this.getTicket, 60000);
            },
            sendMessage(v) {
                this.loading = true;

                let formData = new FormData();

                formData.append('type', v === 1 ? 'Text' : 'Img');
                formData.append('img', this.form.img);
                formData.append('message',  this.form.message);

                axios.post('/api/tickets/info/' + this.id + '/msg/send', formData,
                    {headers: {'Content-Type': 'multipart/form-data'}})
                    .then((res) => {
                        if (res.data.v === 'success') {
                            this.getTicket();
                            this.closeImg();
                            this.clearMessage();
                            this.$toast.success(res.data.status, { icon: 'mdi-check-circle' });
                        } else {
                            this.$toast.warning(res.data.status, { icon: 'mdi-information' });
                        }
                    }).catch(err => {
                        this.handleErrors(err.response.data.errors);
                    }).then(() => {
                        this.loading = false;
                    });
            },
            onFileChanged(img) {
                let input = img.target.files[0];

                if (input) {
                    const reader = new FileReader;
                    reader.onload = e => {
                        this.img = e.target.result;
                    };
                    reader.readAsDataURL(input);
                }
                this.form.img = input;
                this.view = true;
            },
            getImg(id) {
                const items = this.messages;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.img = '/' + items[i].text;
                    }
                }
                this.view = true;
            },
            closeImg() {
                this.$refs.uploader.value = null;
                this.img = null;
                this.form.img = null;
                this.view = false;
            },
            clearMessage() {
                this.$refs.form.reset();
            },
            openTicket(id) {
                this.$swal({
                    title: '¿Esta seguro que desea reabrir este reclamo?',
                    type: 'warning',
                    confirmButtonText: 'Si, reabrir',
                    cancelButtonText: 'No, cancelar'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        axios.get('/api/tickets/open/' + id).then((res) => {
                            if (res.data.v === 'success') {
                                this.getTicket();
                                this.$toast.success(res.data.status, {icon: 'check-circle'});
                            } else {
                                this.$toast.error(res.data.status, {icon: 'mdi-close-circle'});
                            }
                        }).catch(err => {
                            this.handleErrors(err.response.data.errors);
                        });
                    }
                });
            },
            closeTicket(id) {
                this.$swal({
                    title: '¿Esta seguro que desea cerrar este reclamo?',
                    type: 'warning',
                    confirmButtonText: 'Si, cerrar',
                    cancelButtonText: 'No, cancelar'
                }).then((result) => {
                    if (result.value) {
                        this.loading = true;

                        axios.get('/api/tickets/close/' + id).then((res) => {
                            if (res.data.v === 'success') {
                                this.getTicket();
                                this.$toast.success(res.data.status, {icon: 'check-circle'});
                            } else {
                                this.$toast.error(res.data.status, {icon: 'mdi-close-circle'});
                            }
                        }).catch(err => {
                            this.handleErrors(err.response.data.errors);
                        });
                    }
                });
            }
        },
        destroyed() {
            clearTimeout(this.timeout);
        }
    }
</script>

<style scoped>

</style>
